import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="12" cy="12" r="12" fill="#243E81"/> <circle cx="12" cy="12" r="12" fill="#fff" fill-opacity=".5"/> <path fill="#fff" d="M13.649 17.961a6.13 6.13 0 0 1-3.18-.908 6 6 0 0 1-2.19-2.433H6.771a.685.685 0 0 1-.682-.681v-3.715a.685.685 0 0 1 .682-.681h1.443a6.06 6.06 0 0 1 2.191-2.547 5.93 5.93 0 0 1 3.244-.957.685.685 0 0 1 .68.681v10.56a.685.685 0 0 1-.68.681m2.495-2.824a.4.4 0 0 1-.325-.162.394.394 0 0 1 .065-.568 3.166 3.166 0 0 0 0-4.963.404.404 0 1 1 .503-.633 3.98 3.98 0 0 1 1.525 3.115 3.93 3.93 0 0 1-1.525 3.114.33.33 0 0 1-.243.097"/>' }
  })
);